import z from 'zod';

export const rstErrorCodeEnum = z.enum(['RST-VLD-1', 'RST-VLD-2', 'RST-CP-1', 'RST-CP-2']);

export const remoteStartTransactionError = z.object({
  type: z.enum(['managed_error']),
  errors: z.object({
    code: rstErrorCodeEnum,
    title: z.string(),
    message: z.string().nullable(),
    user_action: z.string().nullable(),
    metadata: z.record(z.unknown()).nullable(),
  }),
});

export type RemoteTransactionError = z.infer<typeof remoteStartTransactionError>;

export const remoteTransactionDetailEnum = z.enum(['Accepted', 'Rejected', 'Failed']);

export const remoteTransactionResponse = z.object({
  detail: remoteTransactionDetailEnum,
  task_id: z.string(),
});

export type RemoteTransactionResponse = z.infer<typeof remoteTransactionResponse>;
